var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.17 8.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47.82c-.47-.53-1.1-.82-1.84-.82-1.12,0-1.65.58-2.05,1.12-.4-.54-.93-1.12-2.05-1.12-.73,0-1.37.28-1.84.82C.16,1.43-.09,2.32.03,3.22c.12.9.6,1.86,1.35,2.72.83.94,1.92,1.67,3.15,2.1.02,0,.04.01.06.01s.04,0,.06-.01c1.23-.43,2.32-1.15,3.15-2.1.75-.85,1.23-1.82,1.35-2.72.12-.89-.13-1.79-.67-2.4ZM8.76,3.17c-.2,1.56-1.7,3.59-4.17,4.47C2.11,6.76.62,4.73.41,3.17c-.1-.78.11-1.57.58-2.1.39-.45.93-.68,1.55-.68,1.05,0,1.47.58,1.87,1.15l.02.03c.04.05.1.08.16.08s.12-.03.16-.08l.02-.03c.4-.56.82-1.15,1.87-1.15.62,0,1.15.24,1.55.68.46.53.68,1.31.58,2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31,2.35c.05-.09.01-.21-.08-.26-.09-.05-.21-.01-.26.08l-1.26,2.37h1.11l-.79,1.5c-.05.09-.01.21.08.26.03.02.06.02.09.02.07,0,.14-.04.17-.1l1.09-2.07h-1.11l.96-1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon 2.4a35bbee6563f86cae00fa75c593914d.svg";
export { ForwardRef as ReactComponent };